module.exports = __webpack_public_path__ + "static/media/taanz.e8c05272.png";